<template>
	<div>
		<div class="d-flex align-items-center">
			<div class="mcqtophead">MCQ</div>
			<div class="mcqtophead">
				Difficulty Level - {{ data.difficultyLevel }}
			</div>
			<div class="mcqtophead">{{ data.marks }} Mark</div>
		</div>

		<div class="questiontext">
			<div class="d-flex">
				<span class="mr-2">Q{{ showindex }}.</span
				><span class="topicDescBreak" v-html-safe="data.question"></span>
			</div>
			<div class="my-3" v-if="data.questionMedia != null">
				<div v-if="isImage(data.questionMediaType)">
					<img class="qb-image-preview" :src="data.questionMedia" alt="" />
				</div>
				<div v-if="isAudio(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'audio'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						class="qb-audio-preview"
					></Media>
				</div>
				<div v-if="isVideo(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'video'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						width="70%"
						height="30%"
						class="qb-vedio-preview"
					></Media>
				</div>
			</div>
			<div>
				<b-row>
					<b-col
						v-for="(i, index) in data.options"
						:key="index"
						class="d-flex"
						cols="6"
						:class="{
							'mt-3': index > 1,
						}"
					>
						<div
							v-if="data.noOfCorrectOptionsAllowed > 1"
							class="ml-3 mcq-checkbox"
						>
							<b-form-checkbox
								v-model.trim="i.check"
								name="some-radios"
								disabled
								><span v-if="i.value"> {{ i.value }}</span>
								<span v-if="i.media">
									<span class="uploaded-option-imagecard">
										<img
											:src="i.media"
											alt=""
											class="w-100 h-100 overflow-hidden"
											style="border-radius: 4px;"
										/>
									</span> </span
							></b-form-checkbox>
						</div>
						<div
							v-else
							class="ml-3"
							:class="
								i.check == true ? 'sec-ques-green' : ' sec-questions-radios'
							"
						>
							<b-form-radio
								name="some-radios"
								class="sec-ques-style"
								v-model="selected"
								disabled
								><span v-if="i.value"> {{ i.value }}</span>
								<span v-if="i.media">
									<span class="uploaded-option-imagecard">
										<img
											:src="i.media"
											alt=""
											class="w-100 h-100 overflow-hidden"
											style="border-radius: 4px;"
										/>
									</span> </span
							></b-form-radio>
						</div>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
export default {
	name: "mcqAnswer",
	props: {
		data: Object,
		showindex: Number,
	},
	data() {
		return {
			selected: "first",
		};
	},
	methods: {
		isImage,
		isVideo,
		isAudio,
	},
};
</script>
